module.exports = __webpack_public_path__ + "static/img/logo.784f4461.png";